<template>
    <normal-page name="About">
        <v-lazy-image src="/img/pages/about/about-600.jpg" alt="about" class="image-glow mb-8 h-auto w-[15rem] animate-eclipse-rise sm:float-right sm:ml-10 sm:w-[18rem] 2xl:w-[20rem]" />

        <p class="mb-4 font-serif text-2xl font-light italic tracking-wide sm:text-3xl">
            Funus – Heavy Shoegaze from the Deepest Places
        </p>
        <p class="mb-6 text-lg font-light leading-relaxed text-foam/70">
            Deep rhythms. Distorted guitars. Resonating vocals. Melancholic atmospheres. Real, weathered emotions carved by life itself. This is the world of Funus.
        </p>
        <p class="mb-3 font-light leading-relaxed text-foam/70">
            Founded in 2006 by Dutch multi-instrumentalist, songwriter, and producer <i>Ruben Vermeulen</i>, Funus is a personal exploration into the darker corners of the human experience.
            Being evolved from raw black metal into genres like shoegaze and post-metal, Vermeulen crafts immersive soundscapes where vulnerability meets sonic intensity: an authentic sound
            drenched in thick layers of chorus, reverb and emotional weight.
        </p>
        <p class="mb-3 border-l border-foam/20 pl-6 font-serif text-2xl font-light italic leading-relaxed text-foam/90">
            Funus is more than music — it’s a form of processing.
        </p>
        <p class="mb-5 font-light leading-relaxed text-foam/70">
            With introspective lyrics that touch on loneliness, personal transformation, and inner confrontation, each song feels like a diary entry dressed in distortion. Heavy drums and roaring
            guitars intertwine with dreamy vocals and fragile acoustic moments, pulling the listener deep into layered, emotional narratives. Albums are approached as complete bodies of work
            portraying immersive journeys rather than collections of songs.
        </p>
        <p class="mb-5 font-light leading-relaxed text-foam/70">
            Originally conceived as a solo studio project, Funus took shape on stage between 2009 and 2011 with a rotating lineup of live musicians. During this time, the band performed
            extensively
            across the Netherlands and released its first EP, <i>Funus (2009)</i>, followed by the early test-recording <i>Rosefield Road (2011)</i>, both serving as raw introductions to Ruben’s
            sonic
            vision.
        </p>
        <p class="mb-5 font-light leading-relaxed text-foam/70">
            The project took a bold creative turn with the 2016 full-length <i>Adrift Alone</i>: a conceptual album inspired by Elisabeth Kübler-Ross’s five stages of grief. Blending black metal
            and
            doom elements with delicate acoustic textures, the record pushed the boundaries of genre and storytelling. <i>Adrift Alone</i> received widespread acclaim from underground e-zines
            across
            Europe and featured the definitive version of <i>Rosefield Road</i>.
        </p>
        <p class="mb-5 font-light leading-relaxed text-foam/70">
            After a period of reflection, Ruben returned to writing in 2020, this time embracing even deeper introspection. The result was <i>MONO (2023)</i>, a haunting, immersive album that
            expanded
            the sonic palette of Funus. With guest vocals by <i>Sabina Knol</i>, the record added a new emotional dimension and was met with strong critical praise for its raw honesty and textural
            complexity.
        </p>
        <p class="mb-5 font-light leading-relaxed text-foam/70">
            Now, Funus stands at the edge of a new chapter.
        </p>
        <p class="font-light leading-relaxed text-foam/70">
            The upcoming album, <i>Dreamless Water</i>, promises to be the most personal and atmospheric to date. It represents an evolution of the project’s core themes and sound. Preceded by
            brand new upcoming singles, this release will further define Funus as a singular voice in the world of heavy shoegaze and introspective metal.
        </p>
        <div class="clear-both" />
    </normal-page>
</template>

<script>
    // Components
    import NormalPage from '@/components/layout/pages/NormalPage';
    import VLazyImage from 'v-lazy-image';

    export default {
        components: {
            NormalPage,
            VLazyImage,
        },
    };
</script>
